/**代理商路由 */
export default {
    name: 'agent',
    path: 'agent',
    meta: {title:'代理商'},
    component: ()=>import('@/pages/index.vue'),
    children:[
        {
            name: 'agent-list',
            path: 'list',
            meta: { title: '代理商列表' },
            component: ()=>import('@/pages/agent/list.vue')
        },
        {
            name: 'agent-grade',
            path: 'grade',
            meta: { title: '代理商等级' },
            component: ()=>import('@/pages/agent/grade.vue')
        }
    ]
    
}